import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const StyledLabel = styled.div`
    display: grid;
    place-content: center;
    place-items: center;
    padding-left: ${tokens.label.paddingX}px;
    padding-right: ${tokens.label.paddingX}px;
    height: ${tokens.label.height}px;
    background-color: black;
    border-radius: 999px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
`;

export const Text = styled.p`
    ${styledTypography.allianceBase};
    font-size: ${tokens.label.fontSize}px;
    font-weight: 700;
`;
